import ThemeRow from '../ThemeRow/ThemeRow'
import styles from './SubjectGroup.module.scss'

const SubjectGroup = ({ sub, progressByTheme, assignmentsByTheme, setStatus }) => {
  return (
    <div className={styles.subject}>
      <div className={styles.subjectTitle}>{sub.name || sub.title}</div>
      <div className={styles.themes}>
        {(sub.themes || []).map((th) => {
          const cur = progressByTheme[th.id]
          const status = cur?.status || 'not_started'
          const themeAss = assignmentsByTheme[th.id] || []
          return (
            <ThemeRow
              key={th.id}
              theme={th}
              status={status}
              themeAss={themeAss}
              setStatus={setStatus}
            />
          )
        })}
      </div>
    </div>
  )
}

export default SubjectGroup
